import { TextSelection, } from 'prosemirror-state';
export const createParagraphInheritAttrsTr = (state) => {
    const { selection } = state;
    if (!(selection instanceof TextSelection) || !selection.empty) {
        return null;
    }
    const node = selection.$from.node();
    if (!node.isTextblock || node.type.spec.code) {
        return null;
    }
    if (selection.$from.nodeAfter) {
        return null;
    }
    const { tr, schema } = state;
    const { from } = selection;
    tr.insert(from + 1, schema.nodes.paragraph.create(node.attrs));
    tr.setSelection(TextSelection.create(tr.doc, from + 2));
    return tr;
};
/**
 * 当光标位于一个非代码 textBlock 末尾时，在其后创建一个同 attrs 的空段落
 */
export const createParagraphInheritAttrs = (state, dispatch) => {
    const tr = createParagraphInheritAttrsTr(state);
    if (!tr) {
        return false;
    }
    dispatch === null || dispatch === void 0 ? void 0 : dispatch(tr);
    return true;
};
//# sourceMappingURL=createParagraphInheritAttrs.js.map